import { safeSessionGet, safeSessionSet } from './safe-storage'

const RELOAD_KEY = 'vite_preload_reload_at'
const RELOAD_GUARD_MS = 30_000

export function shouldReloadAfterPreloadError(now = Date.now()): boolean {
  const stored = safeSessionGet(RELOAD_KEY)
  if (wasPreloadReloadRecent(stored, now)) return false
  const mark = String(now)
  safeSessionSet(RELOAD_KEY, mark)
  // A mark that did not persist cannot stop the next load reloading too.
  return safeSessionGet(RELOAD_KEY) === mark
}

export function wasPreloadReloadRecent(
  stored: string | null,
  now: number,
): boolean {
  const previous = stored === null ? null : Number(stored)
  return (
    previous !== null &&
    Number.isFinite(previous) &&
    now - previous < RELOAD_GUARD_MS
  )
}
